import { useState } from "react";
import { api, errMsg } from "@/lib/api";
import { Egg, Loader2, KeyRound } from "lucide-react";

export default function ResetPassword() {
  const params = new URLSearchParams(window.location.search);
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setMsg("");
    if (password.length < 6) return setErr("Şifre en az 6 karakter olmalı");
    if (password !== confirm) return setErr("Şifreler eşleşmiyor");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setMsg("Şifreniz güncellendi. Giriş sayfasına yönlendiriliyorsunuz...");
      setTimeout(() => { window.location.href = "/"; }, 2000);
    } catch (e2) {
      setErr(errMsg(e2, "Sıfırlama başarısız"));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <form onSubmit={submit} className="w-full max-w-sm" data-testid="reset-form">
        <div className="flex items-center gap-2.5 mb-8">
          <div className="h-10 w-10 rounded-lg bg-primary flex items-center justify-center"><Egg className="text-primary-foreground" size={22} /></div>
          <span className="font-head font-extrabold text-2xl tracking-tight">KümesPro</span>
        </div>
        <h1 className="font-head text-2xl font-bold tracking-tight">Şifre Sıfırla</h1>
        <p className="text-sm text-muted-foreground mt-1 mb-6">Yeni şifrenizi belirleyin</p>

        {err && <div className="mb-4 rounded-lg bg-destructive/10 text-destructive text-sm px-3 py-2.5" data-testid="reset-error">{err}</div>}
        {msg && <div className="mb-4 rounded-lg bg-primary/10 text-primary text-sm px-3 py-2.5" data-testid="reset-success">{msg}</div>}

        <label className="block text-[11px] uppercase tracking-wide font-semibold text-muted-foreground mb-1.5">Yeni Şifre</label>
        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password"
          className="h-11 w-full rounded-lg border border-input bg-background px-3 text-sm mb-4 focus:ring-2 focus:ring-primary outline-none" />
        <label className="block text-[11px] uppercase tracking-wide font-semibold text-muted-foreground mb-1.5">Yeni Şifre (Tekrar)</label>
        <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="reset-confirm"
          className="h-11 w-full rounded-lg border border-input bg-background px-3 text-sm mb-6 focus:ring-2 focus:ring-primary outline-none" />

        <button type="submit" disabled={loading || !token} data-testid="reset-submit"
          className="h-11 w-full inline-flex items-center justify-center gap-2 rounded-full bg-primary text-primary-foreground text-sm font-semibold hover:bg-primary/90 transition-colors disabled:opacity-50">
          {loading ? <Loader2 className="animate-spin" size={18} /> : <KeyRound size={18} />} Şifreyi Güncelle
        </button>
        <a href="/" className="mt-4 block text-sm text-primary hover:underline text-center">Girişe dön</a>
      </form>
    </div>
  );
}
